export default __webpack_public_path__ + "static/media/Minotaur.ff2a4d32.png";